import React from 'react';

import { IconButton, styled, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import Close from 'components/SvgComponents/icons/Close';

const Div_Wrapper = styled('div', { shouldForwardProp: prop => prop !== 'hasError' })(
  ({ theme, hasError }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(0.5, 2),
    backgroundColor: hasError ? theme.palette.error.light : theme.palette.background.white,
    borderRadius: 4,
    '& button': {
      padding: 0,
      margin: 0,
    },
  }),
);

const SearchTextFieldItem = ({ value, hasError, onRemove }) => (
  <Div_Wrapper hasError={hasError}>
    <Typography variant={hasError ? 'subtitleError' : 'subtitleLight'} component="span">
      {value}
    </Typography>
    <IconButton disableRipple onClick={() => onRemove(value)}>
      <Close width={12} height={14} />
    </IconButton>
  </Div_Wrapper>
);

SearchTextFieldItem.propTypes = {
  value: PropTypes.string.isRequired,
  hasError: PropTypes.bool,
  onRemove: PropTypes.func.isRequired,
};

export default SearchTextFieldItem;
